/* src/app/modules/shared/navbar/navbar.component.scss */
a {
  color: rgb(255, 255, 255);
}
.navbar-nav .nav-link.active,
.navbar-brand:hover,
.navbar-nav .nav-link.show,
.navbar-nav .nav-link:hover {
  color: #ffffff;
  font-weight: bold;
}
.navbar {
  border-bottom: none;
  padding: 1vh;
}
.navbar-toggler {
  background-color: white;
}
.navbar-brand:hover {
  color: white;
  font-weight: bold;
  text-shadow: 0px 0px 1px rgb(255, 255, 255);
}
.navbar-brand:focus {
  color: white;
  font-weight: bold;
}
.nav-logo {
  max-height: 40px;
}
.dropdown-menu {
  background-color: #004877;
  color: white;
}
.dropdown-item:hover {
  background-color: #000000;
  color: white;
}
/*# sourceMappingURL=navbar.component-4RMAZKRX.css.map */
